import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { useEffect, useState } from "react";
import { useGetCompletedPlanCounter } from "../../hooks/useGetDataQuery";
import { BlockUI } from "primereact/blockui";

const CompletedPlans = ({t}: any) => {
    const today = new Date();
    const sixMonthAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);

    const [completedPlansDate, setCompletedPlansDate] = useState<any>(today);
    const [completedPlansData, setCompletedPlansData] = useState<any>({
        achieved: 0,
        total: 0
    });

    const { data, isPending } = useGetCompletedPlanCounter();

    useEffect(() => {
        if(data && data.success) {
            const temp = {
                achieved: 0,
                total: 0
            }

            const selectedMonth = completedPlansDate ? completedPlansDate.getMonth() + 1 : null;
            const selectedYear = completedPlansDate ? completedPlansDate.getFullYear() : null;

            if(selectedMonth && selectedYear) {
                const selectedData = data.data.find((item: any) => item.month === selectedMonth && item.year === selectedYear);
                if(selectedData) {
                    temp.achieved = selectedData.completedPlanCount;
                    temp.total = selectedData.totalPlanCount;
                }
            }

            setCompletedPlansData(temp);
        }
    }, [data, completedPlansDate])

    const percent = completedPlansData.total > 0 ? ((completedPlansData.achieved / completedPlansData.total) * 100).toFixed(2) : 0;

    return (
        <div className="col">
            <BlockUI
                blocked={isPending}
                style={{ backgroundColor: "transparent", borderRadius: "24px" }}
                template={
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dotlottie-player
                        src="https://lottie.host/102dcba8-b9a9-447a-af8e-3e134e77ea0c/Esb1U6xLam.lottie"
                        background="transparent"
                        speed="1"
                        style={{ width: "3rem", height: "3rem" }}
                        loop
                        autoplay
                    />
                </div>
                }
            >
                <Card className="h-16rem" style={{ borderRadius: "24px", position: "relative" }}>
                    <div className='flex justify-content-between align-items-center'>
                        <p className='m-0 text-lg' style={{ color: '#727A99' }}>{t("completedPlans")}</p>
                        <Calendar
                            style={{ width: "7rem", height: "2rem" }}
                            value={completedPlansDate}
                            onChange={(e: any) => setCompletedPlansDate(e.value)}
                            view="month"
                            dateFormat="M yy"
                            minDate={sixMonthAgo}
                            maxDate={today}
                        />
                    </div>
                    <div className="flex flex-column pt-3 px-5 gap-3">
                        <div style={{ color: '#AEB5C9', fontSize: '1.25rem', fontWeight: 500, textAlign: 'left' }}>{t("achieved")} / {t("total")}</div>
                        <div style={{ color: '#2D3967', fontSize: '2rem', fontWeight: 600, textAlign: 'left', lineHeight: 1 }}>{completedPlansData.achieved}/{completedPlansData.total}</div>
                        <div style={{ color: '#727A99', fontSize: '1rem', fontWeight: 500, textAlign: 'left' }}>%{percent} {t("completed")}</div>
                        <div style={{ width: '100%', height: '1rem', background: '#E6EAF2', borderRadius: 8, overflow: 'hidden' }}>
                            <div style={{ width: `${percent}%`, height: '100%', background: '#2ED6A1', borderRadius: 8, transition: 'width 0.5s' }} />
                        </div>
                    </div>
                </Card>
            </BlockUI>
        </div>
    )
}

export default CompletedPlans;